/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignUpdateWhatsAppAutomation } from '../../axios/campaignUpdateWhatsAppAutomation'
import type {
	CampaignUpdateWhatsAppAutomationError,
	CampaignUpdateWhatsAppAutomationPathParams,
	CampaignUpdateWhatsAppAutomationRequest,
	CampaignUpdateWhatsAppAutomationResponse,
} from '../../types/CampaignUpdateWhatsAppAutomation'

export const campaignUpdateWhatsAppAutomationMutationKey = () =>
	[{ url: '/campaigns/:campaign/whatsapp-automation' }] as const

export type CampaignUpdateWhatsAppAutomationMutationKey = ReturnType<typeof campaignUpdateWhatsAppAutomationMutationKey>

export type CampaignUpdateWhatsAppAutomationVariables = {
	campaign: CampaignUpdateWhatsAppAutomationPathParams['campaign']
	data: CampaignUpdateWhatsAppAutomationRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::updateWhatsAppAutomation */
export function useCampaignUpdateWhatsAppAutomation<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignUpdateWhatsAppAutomationResponse,
		AxiosError<CampaignUpdateWhatsAppAutomationError>,
		CampaignUpdateWhatsAppAutomationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignUpdateWhatsAppAutomationMutationKey(),
		mutationFn: ({ campaign, data }: CampaignUpdateWhatsAppAutomationVariables) =>
			campaignUpdateWhatsAppAutomation(campaign, data, config).then(res => res.data),
		...options,
	})
}
